/* eslint-disable import/prefer-default-export */
export const Constants = {
  registration: {
    successMessage:
      'Please check your email. We’ve sent a verification email to the address you provided.',
  },
  home: {
    successMessage: 'Your personal information was saved successfully.',
    startMessage:
      'Thank you for registering with Calvert Impact Capital. We invite you to learn about our work, and when ready, open an investment account or claim an existing account.',
  },
  purchaseNote: {
    dwollaTermsUrl: 'https://www.dwolla.com/legal/tos/',
    fundingSourceError: 'You must select a bank account',
    interestYearRateError: 'You must select a rate',
    modalQuestion: 'Do you wish to proceed and invest?',
    modalTitle: 'Confirm investment',
    modalYesButtonMethod: 'Purchase Note',
    modalYesButtonText: 'Confirm',
    investmentRequiredError: 'You must provide an investment amount',
    propectusAndDwollaTermsError:
      'Please accept the Dwolla Terms & Conditions and Prospectus before proceeding',
    prospectusTermUrl:
      'http://www.calvertfoundation.org/storage/documents/CF-Community-Investment-Note-Prospectus.pdf',
    legacyFundingSourceMessageFirstLine:
      'Check and wire/ACH transfer may only be used for receiving payments.',
    legacyFundingSourceMessageSecondLine:
      'If you need to purchase a Note funded by a check or wire/ACH transfer, please contact Calvert Impact Capital.',
  },
  failedTransactiondetail: {
    markAsLostMessage:
      'Are you sure you want to mark this transaction as lost?',
    markAsUnlostMessage:
      'Are you sure you want to mark this transaction as unlost?',
    flaggedAsLostSuccessMessage:
      'The transaction was succesfully flagged as lost.',
    flaggedAsUnlostSuccessMessage:
      'The transaction was succesfully flagged as unlost.',
  },
  microDeposits: {
    modalYesButtonText: 'Confirm Micro-Deposits',
  },
  redeem: {
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to cancel this redemption request?',
    modalTitle: 'Cancel redemption',
  },
  accountDetail: {
    modalYesButtonText: 'Confirm',
    modalTitle: 'Account preference',
  },
  fundingSource: {
    modalTitle: 'Notice',
    modalEditProfileButtonText: 'Edit Profile',
    modalYesButtonText: 'Confirm',
    hyperLinkText: 'Terms of Service.',
    hyperLinkUrl: 'https://www.dwolla.com/legal/tos/?whitelabel',
    hyperLinkText2: 'Privacy Policy.',
    hyperLinkUrl2: 'https://www.dwolla.com/legal/privacy?whitelabel',
    retrySelfRegisterDisclaimer:
      'Your identity could not be verified. Please check your profile and make any necessary corrections, then try again. If you need assistance, please contact Calvert Impact Capital.',
    retryDisclamer:
      'Your identity could not be verified by our payment partner. Please check your profile and make any necessary corrections, then try again.',
    legacyDisclamer:
      'Thank you for deciding to use a bank account as part of your Calvert Impact Capital account. We have partnered with Dwolla to securely send payments to, and allow you to invest from, your bank account(s). By proceeding, you agree that you have read and accept Dwolla’s',
    legacyDisclamerAppend:
      ' Please contact Calvert Impact Capital if you have any questions.',
    legacyDisclamerRetry:
      ' If you need assistance, please contact Calvert Impact Capital',
    defaultFundingSourceModalTitle: 'New default bank account',
    deleteFundingSourceModalTitle: 'Delete bank account',
  },
  companyInformation: {
    name: 'Calvert Impact Capital',
  },
  userDetail: {
    modalYesButtonText: 'Confirm',
    modalTitle: 'Personal information',
    modalQuestion: 'Are you sure about these changes?',
    modalQuestionPOBox: 'We identified you are entering a PO Box address. Are you sure about these changes?',
    ModalUserConfirmation: 'Are you sure this is the correct information?',
  },
  investorPreferences: {
    modalTitle: 'Investment Preferences',
    modalYesButtonText: 'Save',
    modalQuestion: 'Are you sure you want to submit your impact preferences?',
    successMessage: 'Your impact preferences were saved successfully.',
  },
  adminPreferences: {
    modalTitle: 'Investment preferences',
    modalYesButtonText: 'Save',
    modalQuestion: 'Are you sure you want to update these preferences?',
    successMessage: 'The preferences were submitted successfully.',
  },
  additionalEmail: {
    modalTitle: 'Additional email',
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to delete this email?',
    successMessageAfterAddition: 'The email was added successfully!',
    successMessageAfterDeletion: 'The email was deleted successfully!',
  },
  updatePrimaryInvestorMessage: {
    institutionAccountMessage: 'Because this is an institution account, this will send transaction notifications to the primary investor but will not affect the bank accounts used for investing.',
    notInstitutionAccountMessage: 'This will send future transaction notifications to the primary investor and make the primary investor\'s bank accounts available for investing using this account.',
  },
  transfer: {
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to cancel this transfer request?',
    modalTitle: 'Cancel transfer',
  },
  purchaseInvestmentNote: {
    // Brokerage is only a valid funding source for account A842 (Cede & Co) in
    // production; lower environments use A1824 as the equivalent test account.
    brokerageEnabledAccountIds: {
      production: ['842'],
      default: ['1824'],
    },
  },
  addFunds: {
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to cancel this add funds request?',
    modalTitle: 'Cancel Add Funds Request',
  },
  richtext: {
    customEditorToolbar: [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ['bold', 'italic', 'underline', 'strike'],
      [
      { align: '' },
      { align: 'center' },
      { align: 'right' },
      { align: 'justify' },
      ],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ indent: '-1' }, { indent: '+1' }],
      [{ color: ['#000000', '#041722', '#050505', '#096633', '#0e1012', '#10171e', '#121517', '#14171a', '#141d26', '#15181c', '#15202b', '#17bf63', '#182430', '#192734', '#1b2836', '#1b95e0', '#1da1f2', '#1da1f2', '#202327', '#244052', '#253341', '#264a9d', '#2f3336', '#325d7d', '#38444d', '#3b4c5c', '#3d4145', '#3d5466', '#512892', '#657786', '#66d397', '#68e090', '#697987', '#6b7d8c', '#6e767d', '#6e767d', '#70c8ff', '#71c9f8', '#794bc4', '#79500b', '#8899a6', '#929ca6', '#929ca6', '#92a4b3', '#97e3ff', '#99350d', '#9f0c3a', '#a37ced', '#a5f2aa', '#aab8c2', '#b8cbd9', '#bea8e2', '#c7b4fa', '#ccd6dd', '#d9d9d9', '#e0245e', '#e6ecf0', '#eaf5fd', '#f098b3', '#f45d22', '#f5f8fa', '#f6809a', '#f89a75', '#ff8d57', '#ffad1f', '#ffb8c2', '#ffbe78', '#ffcb70', '#ffd03f', '#ffe76e', '#ffffff', '#ffffff', '#000000', '#0000ff', '#008000', '#add8e6', '#90ee90', '#ffffe0', '#0000cd', '#9370db', '#ffa500', '#800080', '#ff0000', '#657786', '#657786', '#657786', '#8899a6', '#8899a6', '#8899a6', '#121517', '#141d26', '#d9d9d9', '#d9d9d9', '#e6ecf0', '#ffffff', '#ffffff', '#ffffff', '#ffff00'] },
    { background: ['#000000', '#041722', '#050505', '#096633', '#0e1012', '#10171e', '#121517', '#14171a', '#141d26', '#15181c', '#15202b', '#17bf63', '#182430', '#192734', '#1b2836', '#1b95e0', '#1da1f2', '#1da1f2', '#202327', '#244052', '#253341', '#264a9d', '#2f3336', '#325d7d', '#38444d', '#3b4c5c', '#3d4145', '#3d5466', '#512892', '#657786', '#66d397', '#68e090', '#697987', '#6b7d8c', '#6e767d', '#6e767d', '#70c8ff', '#71c9f8', '#794bc4', '#79500b', '#8899a6', '#929ca6', '#929ca6', '#92a4b3', '#97e3ff', '#99350d', '#9f0c3a', '#a37ced', '#a5f2aa', '#aab8c2', '#b8cbd9', '#bea8e2', '#c7b4fa', '#ccd6dd', '#d9d9d9', '#e0245e', '#e6ecf0', '#eaf5fd', '#f098b3', '#f45d22', '#f5f8fa', '#f6809a', '#f89a75', '#ff8d57', '#ffad1f', '#ffb8c2', '#ffbe78', '#ffcb70', '#ffd03f', '#ffe76e', '#ffffff', '#ffffff', '#000000', '#0000ff', '#008000', '#add8e6', '#90ee90', '#ffffe0', '#0000cd', '#9370db', '#ffa500', '#800080', '#ff0000', '#657786', '#657786', '#657786', '#8899a6', '#8899a6', '#8899a6', '#121517', '#141d26', '#d9d9d9', '#d9d9d9', '#e6ecf0', '#ffffff', '#ffffff', '#ffffff', '#ffff00'] }], // dropdown with defaults from theme
    ['link'],
    ] },
};



// WEBPACK FOOTER //
// ./src/data/static/constants.js